import React from 'react';
import styled from 'styled-components';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin: 20px 0;
`;

const PageButton = styled.button`
  width: 42px;
  height: 42px;
  border-radius: 10px;
  border: none;
  background-color: ${props => props.$active ? '#D2691E' : '#ffffff'};
  color: ${props => props.$active ? '#ffffff' : '#6B6B6B'};
  font-family: 'Pretendard', sans-serif;
  font-weight: ${props => props.$active ? '600' : '400'};
  font-size: 14px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease;
  border: 1px solid ${props => props.$active ? '#D2691E' : '#f0f0f0'};

  &:hover {
    background-color: ${props => props.$active ? '#D2691E' : '#FFF8F2'};
    color: ${props => props.$active ? '#ffffff' : '#D2691E'};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(210, 105, 30, 0.2);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;

const NavButton = styled.button`
  width: 38px;
  height: 38px;
  border: 1px solid #f0f0f0;
  background-color: #ffffff;
  color: #6B6B6B;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #FFF8F2;
    color: #D2691E;
    border-color: #D2691E;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(210, 105, 30, 0.15);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }
`;

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange,
  maxVisiblePages = 5 
}) => {
  const getVisiblePages = () => {
    const pages = [];
    const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  const visiblePages = getVisiblePages();

  return (
    <PaginationContainer>
      <NavButton 
        disabled={currentPage <= 1} 
        onClick={() => onPageChange(currentPage - 1)}
      >
        <ChevronLeft size={20} />
      </NavButton>
      
      {visiblePages.map(page => (
        <PageButton
          key={page}
          $active={page === currentPage}
          onClick={() => onPageChange(page)}
        >
          {page}
        </PageButton>
      ))}
      
      <NavButton 
        disabled={currentPage >= totalPages} 
        onClick={() => onPageChange(currentPage + 1)}
      >
        <ChevronRight size={20} />
      </NavButton>
    </PaginationContainer>
  );
};

export default Pagination;
